import { Sparkles } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { errText, frDate, frDateTime } from "@/components/pipeline/utils";

const RISK = { faible: "ok", moyen: "warn", "élevé": "danger" };

export const LeadAi = ({ leadId, ai, setAi, onUseDate }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { setAi((await api.post(`/pipeline/leads/${leadId}/ai`)).data); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <section className="pl-ai" data-testid="ai-summary-card">
      <header>
        <span className="pl-ai-title"><Sparkles size={15} /> Analyse IA</span>
        <span className="pl-ai-actions">
          <button type="button" className="pl-link" onClick={run} disabled={busy} data-testid="ai-generate-btn">{busy ? "Analyse en cours…" : ai ? "Actualiser" : "Analyser l'opportunité"}</button>
        </span>
      </header>
      {ai ? (
        <>
          <p data-testid="ai-summary-text">{ai.summary}</p>
          <div className="pl-ai-next">
            <small>PROCHAINE ACTION</small>
            <strong data-testid="ai-next-action">{ai.next_action}</strong>
            {ai.next_action_date && (
              <button type="button" className="pl-link" onClick={() => onUseDate(ai.next_action_date)} data-testid="ai-use-date">Planifier la relance au {frDate(ai.next_action_date)}</button>
            )}
          </div>
          {ai.risk && <span className={`pl-badge ai-risk ${RISK[ai.risk] || "info"}`} data-testid="ai-risk">Risque {ai.risk} · {ai.risk_reason}</span>}
          <small className="pl-muted">Généré le {frDateTime(ai.generated_at)}</small>
        </>
      ) : <p className="pl-muted">Résumé de l'historique, prochaine action conseillée et niveau de risque, à partir des commentaires, e-mails et SMS.</p>}
    </section>
  );
};
